import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Category from '../../entities/extranet/category'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface CategoryState extends ListState<Category>{
    editModel: Category;
    loadingPos: boolean;
}
class CategoryModule extends ListModule<CategoryState,any,Category>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Category>(),
        loading:false,
        loadingPos:false,
        editModel: new Category(),
        activeList: new Array<Category>(),
        path: 'categories'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async savePositions(context: ActionContext<CategoryState, any>, payload: any) {
            context.state.loadingPos = true;
            let response = await Ajax.post('/api/categories/positions', payload.data).catch(e => {
                context.state.loadingPos = false;
                return Promise.reject(e);
            });
            context.state.loadingPos = false;
            context.state.list = response.data.result;
            return response.data.result;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const categoryModule=new CategoryModule();
export default categoryModule;
